import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {logOperationalMetric} from "../../util/CommonUtils";

const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getPackageHistoryForParentContainer(parentContainerLabel,
     nodeId, pageSize, pageToken = null, fromEpochMilli = null, toEpochMilli = null) {
    
    const requestBody = {
        "parentContainerLabel": parentContainerLabel,
        "nodeId": nodeId,
        "pageSize": pageSize,
        "pageToken": pageToken,
        "startTime": fromEpochMilli,
        "endTime": toEpochMilli
    }

    const startTime = Date.now();
    
    const request = {
        resourcePath: "/os/getPackageHistoryForParentContainer",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    try {
        const response = await getAPIGatewayDataFromParent(request);
        if (response.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryForParentContainer", true);
            return response.data;
        } else {
            logOperationalMetric(startTime, metricProcessName, "getPackageHistoryForParentContainer", false);
            return {
                packageHistory: [],
                nextPageToken: null
            };
        }
    } catch (error) {
        return {
            packageHistory: [],
            nextPageToken: null
        }
    }
}


// WEBPACK FOOTER //
// ./src/commons/api/GetPackageHistoryForParentContainerResults.js